<style scoped lang="scss">
header {
  width: 100%;
  background: white;
  align-items: center;
  display: flex;
  align-items: center;
  height: 90px;
  border-bottom: 1px solid #e7e9ed;
  margin-bottom: 30px;
  .logo {
    width: 50px;
    margin: 0 auto
  }
}
.card {
  margin-bottom: 5em;
  padding-bottom: 3em;
}
.columns {
  padding: 0 10%
}
</style>

<template>
  <main v-if="loaded">
    <header class="flex-space_between">
      <dr-vector class="logo" :fill="'gradient'" src="@/assets/img/Logo.svg"></dr-vector>
    </header>
    <section  class="container grid-lg">
      <div class="card">
        <header class="card-header">
          <h2>Complete seu cadastro</h2>
        </header>
        <main class="card-body">
          <form @submit.prevent="submit()" class="columns">
            <dr-field
              prefix="form1"
              class="text-left"
              v-for="(field, name) in formData"
              v-bind:form.sync="formData"
              v-bind:field.sync="field"
              v-bind:value.sync="formData[name].value"
              v-bind:validators.sync="$v.formData[name]"
              v-bind:apiErrors.sync="apiErrors[name]"
              :id="name"
              :ref="name"
              :key="'main_'+name">
            </dr-field>
            <label class="form-checkbox">
              <input type="checkbox" v-model="tos">
              <i class="form-icon"></i> <strong>Eu concordo com os <a @click="showTos()">termos de uso</a></strong>
            </label>
            <span class="col-12">
              <br />
              <dr-submit :disabled="$v.$invalid" text="Salvar" :sending="sending"></dr-submit>
            </span>
          </form>
        </main>
      </div>
    </section>
  </main>
</template>

<script>
import drField from '@/components/form/field'
import drSubmit from '@/components/form/submit'
import {formData, validations} from '@/data/formData/registerSecretary'
import { sameAs } from 'vuelidate/lib/validators'
import tos from '@/data/miscData/tos'

export default {
  components: {
    drField,
    drSubmit
  },
  data () {
    return {
      modalUserImage: false,
      loaded: false,
      tos: false,
      isChangePassword: false,
      showForm: true,
      formData,
      apiErrors: this.fn_BUILD_API_ERRORS(formData),
      sending: false,
      username: null
    }
  },
  validations: {
    formData: validations,
    tos: {
      checked: sameAs(function () { return true })
    }
  },
  computed: {
    watchCep () {
      if (this.formData) {
        return this.formData[`address.cep`].value
      }
      return ''
    }
  },
  watch: {
    'watchCep': function (next, prev) {
      if (!next) {
        return
      }
      if (next.length === 9) {
        this.getCep(next)
      }
    }
  },
  mounted () {
    this.$http.get(`/secretary/register/${this.$route.params.token}/validation`, this.$store.getters.getAuthHeader).then(
      (res) => {
        this.username = res.data
        this.fn_HIDE_PROGRESS()
        this.loaded = true
      }
    ).catch(
      (err) => {
        console.log(err)
        this.$store.dispatch('setModalAlert', {
          title: 'Erro',
          body: 'Token inválido',
          size: 'md',
          active: true
        })
        this.$router.push('/login')
      }
    )
  },
  methods: {
    showTos () {
      this.$store.dispatch('setModalAlert', {
        title: 'Termos de uso',
        body: tos,
        size: 'lg',
        active: true
      })
    },
    getCep (v) {
      if (!v) {
        return false
      }
      const self = this
      self.formData['address.cep'].loading = 1
      function handleData (res) {
        if (!res) {
          self.formData['address.cep'].loading = 0
          self.validCep = false
          return
        }
        let cep = {}
        if (res.data.erro) {
          self.validCep = false
          cep.uf = ''
        } else {
          self.validCep = true
          cep = res.data
          cep.uf = self.fn_FIND_UF_CODE(cep.uf).id
        }
        self.formData['address.city.name'].value = cep.localidade || null
        self.formData['address.uf'].value = cep.uf || null
        self.formData['address.district'].value = cep.bairro || null
        self.formData['address.street'].value = cep.logradouro || null
      }
      if (v.length === 9) {
        this.$http.get('https://viacep.com.br/ws/' + v.replace('-', '') + '/json/').then(
          (res) => {
            self.formData['address.cep'].loading = 0
            if (res.data.erro) {
              this.validCep = false
              return
            }
            handleData(res)
          }
        ).catch(
          (err) => {
            handleData()
            console.log(err)
          }
        ).finally(() => {
          this.fn_HIDE_PROGRESS()
        })
      }
    },
    submit () {
      this.sending = true
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.sending = false
        return
      }
      let data = this.fn_COPY_OBJECT(this.formData)

      data['contactPhone'].value = this.fn_NUMBERS_ONLY(data['contactPhone'].value)
      data['cpf'].value = this.fn_NUMBERS_ONLY(data['cpf'].value)
      data['address.cep'].value = this.fn_NUMBERS_ONLY(data['address.cep'].value)
      data = this.fn_EXPAND_OBJECT(data)
      data.hasTermsOfUse = this.tos
      data.address.latitude = 0
      data.address.longitude = 0
      let predate = data.dateOfBirth.split('/')
      data.dateOfBirth = `${predate[2]}-${predate[1]}-${predate[0]}`

      this.$http.put(`/secretary/register/${this.$route.params.token}`, {'register': { user: data }}, this.$store.getters.getAuthHeader).then(
        (res) => {
          const self = this
          this.$store.dispatch('setModalAlert', {
            title: 'Sucesso',
            body: 'Cadastro enviado com sucesso',
            size: 'md',
            active: true,
            callback () {
              self.$store.dispatch('setModalAlert')
              self.loaded = false
              self.login(self)
            }
          })
          this.sending = false
        }
      ).catch(
        (err) => {
          console.log(err, data)
          if (err.status === 400 || err.code === 400) {
            this.fn_FLATTEN_OBJECT(err.errors.children.user.children).then(
              (res) => {
                for (let field in res) {
                  this.apiErrors[field.replace(/.children|.errors/g, '')] = res[field]
                }
                this.sending = false
                this.$store.dispatch('setModalAlert', this.ERROR_MESSAGES.modal.form)
              }
            )
          } else {
            this.sending = false
            this.$store.dispatch('setModalAlert', this.ERROR_MESSAGES.modal.server)
          }
        }
      )
    },
    login () {
      this.fn_SHOW_PROGRESS()
      console.log(this)
      let data = {
        _username: this.username,
        _password: this.formData['plainPassword.first'].value
      }
      console.log(this)
      this.$http.post('/login_check', data).then(
        (res) => {
          this.$store.dispatch('setAuth', res.data)
          this.$router.replace(`/secretary`)
          this.fn_HIDE_PROGRESS()
        }
      ).catch(() => {
        this.sending = false
        this.fn_HIDE_PROGRESS()
        this.$store.dispatch('setModalAlert', {
          title: 'Erro de autenticação',
          body: 'Acesso não permitido',
          size: 'md',
          active: true
        })
      })
    }
  }
}
</script>
